module.exports = __webpack_public_path__ + "img/img_lianxi_changsha@3x.c9cde9cc.png";